import React from "react";
import style from "./ButtonIcon.module.scss";
import { Oval } from "react-loader-spinner";

function ButtonIcon({
  children,
  bgColor,
  onClick,
  textColor = "#000",
  className,
  disabled = false,
  size = "medium",
  isLoading = false,
  type = "button",
  ...props
}) {
  return (
    <button
      className={`${size == "medium" ? style.button : style.button_small} ${className}`}
      style={{
        backgroundColor: bgColor,
        color: textColor,
      }}
      onClick={onClick}
      disabled={disabled || isLoading}
      type={type}
      {...props}
    >
      {isLoading && (
        <Oval
          visible={true}
          height="16"
          width="16"
          color="#FFF"
          ariaLabel="oval-loading"
          strokeWidth="6"
          strokeWidthSecondary="6"
        />
      )}
      {children}
    </button>
  );
}

export default ButtonIcon;
